import React, { useState,useEffect } from 'react';
import { Link } from 'react-router-dom';
import logo from "../assets/111.png";
import PrivacyPolicy from "../assets/Drivve_Consolidated_Privacy_Policy.pdf";
import TermsConditions from "../assets/Drivve_Consolidated_Terms_and_Conditions.pdf";
import Disclaimer from "../assets/Drivve_Consolidated_Disclaimer.pdf";
import CookiesPolicy from "../assets/Drivve_Consolidated_Cookies_Policy.pdf";

const Footer = () => {
  const [showModal, setShowModal] = useState(false);
const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

useEffect(() => {
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 768);
  };

  window.addEventListener("resize", handleResize);

  return () => window.removeEventListener("resize", handleResize);
}, []);

  return (
    <>
      <footer className="footer">
        <div className="footer-container">

          {/* BRAND */}
          <div className="footer-section">
            <div className="footer-logo">
              <img src={logo} alt="Drivve" className="footer-logo-img" />
            </div>

           <p className="footer-description">
  Carpooling made simple, affordable, and eco-friendly.
  <br />
  Join commuters who trust Drivve&trade; for smarter daily travel.
</p>

<div
  style={{
    display: "flex",
    justifyContent: isMobile ? "center" : "flex-start", // ⭐ MAGIC
    alignItems: "center",
    gap: "14px",
    marginTop: "18px",
    width: "100%",
  }}
>


  {/* INSTAGRAM */}
  <a
    href="https://www.instagram.com/social.drivve?igsh=MTNrczdjZGxpNjE5Yw=="
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Instagram"
    style={iconStyle}
  >
    <i className="bi bi-instagram" style={iconInner} />
  </a>

  {/* FACEBOOK */}
  <a
    onClick={() => setShowModal(true)}
    aria-label="Facebook"
    style={iconStyle}
  >
    <i className="bi bi-facebook" style={iconInner} />
  </a>

  {/* LINKEDIN */}
  <a
    onClick={() => setShowModal(true)}
    aria-label="LinkedIn"
    style={iconStyle}
  >
    <i className="bi bi-linkedin" style={iconInner} />
  </a>
</div>

          </div>

          {/* QUICK LINKS */}
<div className="footer-section" >
            <h3>Quick Links</h3>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/download">Download</Link></li>
              <li><Link to="/survey">Feedback</Link></li>
            </ul>
          </div>

          {/* CONTACT */}
          <div className="footer-section" >
            <h3>Contact Us</h3>
            <ul className="contact-list">
              <li>
                 Support@drivve.in
              </li>
            </ul>
          </div>
          <div className="footer-section" >
            <h3>Legal</h3>
            <ul>
              <li>
  <a
    href="/terms-and-conditions"
    target="_blank"
    rel="noopener noreferrer"
  >
    Terms & Conditions
  </a>
</li>

<li>
  <a
    href="/privacy-policy"
    target="_blank"
    rel="noopener noreferrer"
  >
    Privacy Policy
  </a>
</li>

<li>
  <a
    href="/cookies-policy"
    target="_blank"
    rel="noopener noreferrer"
  >
    Cookies Policy
  </a>
</li>

<li>
  <a
    href="/disclaimer"
    target="_blank"
    rel="noopener noreferrer"
  >
    Disclaimer
  </a>
</li>            </ul>
          </div>
        </div>

        {/* BOTTOM */}
        <div className="footer-bottom">
<p style={{ color: "#fff" }}>
  © {new Date().getFullYear()} Drivve. All rights reserved.
</p>
        </div>
      </footer>


      {/* ✅ COMING SOON MODAL */}
      {showModal && (
        <div style={styles.overlay}>
          <div style={styles.modal}>

            {/* <button
              style={styles.closeBtn}
              onClick={() => setShowModal(false)}
            >
              ✕
            </button> */}

           <h2 style={styles.title}>
  Coming Soon
</h2>


            <p style={styles.text}>
              Our social media pages are launching soon!
              Stay tuned for updates.
            </p>
<button
  onClick={() => setShowModal(false)}
  style={styles.gotItBtn}
  onMouseOver={(e) => {
    e.currentTarget.style.background = "#0f2c5c";
    e.currentTarget.style.transform = "translateY(-2px)";
  }}
  onMouseOut={(e) => {
    e.currentTarget.style.background = "#184080";
    e.currentTarget.style.transform = "translateY(0)";
  }}
>
  Got it
</button>

          </div>
        </div>
      )}

    </>
  );
};


/* ✅ SINGLE STYLE OBJECT */

const styles = {
gotItBtn: {
  marginTop: "28px",
  padding: "14px 38px",
  borderRadius: "40px", // ⭐ pill shape
  border: "none",
  background: "#284e8f",
  color: "#fff",
  fontSize: "16px",
  fontWeight: "600",
  cursor: "pointer",
  transition: "0.25s ease",
},


overlay: {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background: "rgba(19,15,15,0.55)", // softer
  backdropFilter: "blur(10px)", // stronger blur = premium
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 999,
},


  modal: {
  background: "#f4f6f8",
  padding: "clamp(35px,5vw,55px)",
  borderRadius: "22px",
  width: "90%",
  maxWidth: "520px",
  textAlign: "center",
  position: "relative",
  boxShadow: "0 40px 120px rgba(0,0,0,0.25)",
},


  closeBtn: {
    position: "absolute",
    top: "12px",
    right: "14px",
    border: "none",
    background: "transparent",
    fontSize: "20px",
    cursor: "pointer",
    color: "#130F0F"
  },

 title: {
  color: "#184080",
  fontWeight: "800",
  marginBottom: "10px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
},


text: {
  color: "130f0f",
  lineHeight: "1.7",
  fontSize: "16px",
  marginTop: "10px",
},


};
const iconStyle = {
  width: "clamp(38px,4vw,44px)",
  height: "clamp(38px,4vw,44px)",
  borderRadius: "50%",
  background: "rgba(255,255,255,0.12)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  transition: "0.3s",
};

const iconInner = {
  color: "#ffffff",
  fontSize: "clamp(16px,2vw,20px)",
};

export default Footer;
